import axios from 'axios'
import * as vars from './vars';

export function getAdminPageGrowthData(getAdminPageGrowthDataRequest, jwt) {
    return axios({
        method: 'POST',
        url: vars.baseURL + `/api/v3/admin/GetAdminPageGrowthData`,
        headers: {api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data: getAdminPageGrowthDataRequest
    })
}

export function createNewGrowthCampaign (createNewCampaignRequest, jwt){
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/admin/CreateNewGrowthCampaign',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data : createNewCampaignRequest
    })
}

export function createNewGrowthElement (createNewGrowthElementRequest, jwt){
    return axios({
        method: 'POST',
        url: vars.baseURL + '/api/v3/admin/CreateNewGrowthElement',
        headers: { api_key: vars.apiKey, 'X-XSRF-TOKEN': vars.csrfToken, 'Authorization': `Bearer ${jwt}`},
        data : createNewGrowthElementRequest
    })
}